module.exports = __webpack_public_path__ + "static/media/Tombeau-picture-1.e4603169.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-picture-1.jpg
// module id = 613
// module chunks = 0 1 2 3 4 6